export default {
    SET_AREAS: "SET_AREAS",
    UPDATE_AREA: "UPDATE_AREA",
    BUILD_FILTERS: "BUILD_FILTERS",
    SET_SEARCH_FILTERS: "SET_SEARCH_FILTERS",
    ADD_TO_ZIP: "ADD_TO_ZIP",
    REMOVE_FROM_ZIP: "REMOVE_FROM_ZIP",
    CLEAR_ZIP_SELECTIONS: "CLEAR_ZIP_SELECTIONS",
    SET_SEARCH_RESULTS: "SET_SEARCH_RESULTS",
    SET_SEARCH_ERROR: "ERROR",
    SET_LOADING: "SET_LOADING",
    PLAY_VIDEO: "PLAY_VIDEO",
    CLOSE_VIDEO: "CLOSE_VIDEO",
    UPDATE_RESOURCE: "UPDATE_RESOURCE",
    SET_EDITING_RESOURCE: "SET_EDITING_RESOURCE",
    SET_EDITING_RESOURCE_DATA: "SET_EDITING_RESOURCE_DATA",
    UNLOCK_TABS: "UNLOCK_TABS",
    SET_AREA_RESOURCES: "SET_AREA_RESOURCES",
    DELETE_RESOURCE: "DELETE_RESOURCE",
}
